import { TextListCell, toTableCellMultiValue } from '../../Table'

import { getUserAccessLabelList } from './DocumentTableRowAccess.utils'

function DocumentTableRowAccess({ value, ...restProps }) {
  const listValue = getUserAccessLabelList(value).map(toTableCellMultiValue)

  return <TextListCell {...restProps} value={listValue} />
}

export default DocumentTableRowAccess
